import React from 'react';
import styled from 'styled-components';

const IframeStyled = styled.iframe`
	background: #fff;
	width: 100%;
	height: 100vh;

	max-width: 484.5pt;
	padding: 0 20px;
	padding-bottom: 100px; !important;

	* {
		padding: 0 !important;
	}
`;

const LegalPage = styled.div`
	background: #fff;
	display: flex;
	justify-content: center;

	padding-top: 70px;
	padding-bottom: 70px;
`;

const UpdatedDocViewer = ({ src }) => (
	// eslint-disable-next-line jsx-a11y/iframe-has-title
	<LegalPage>
		<IframeStyled title="Title1" src={src} frameBorder="0" />
	</LegalPage>
);

export default UpdatedDocViewer;
